var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasStreamAnnouncement)?_c('streamAnnouncement'):(_vm.showAnnouncement)?_c('announcementContent'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }